export default "__VITE_ASSET__CRYu$HLd__"